import * as React from 'react'
import * as styles from './BasicBadge.module.scss'
import * as cn from 'classnames'

interface BasicBadgeProps {
  children: React.ReactChild | React.ReactChild[]
  classNames: string[] | (string | { [x: string]: boolean; })[]
}

const BasicBadge = ({ children, classNames }: BasicBadgeProps) => (
  <div className={cn(styles.Badge, 'tst-badge', ...classNames)}>
    {children}
  </div>
)

export default BasicBadge
